export const UPDATE_USER = 'SessionContext/updateUser';
export const UPDATE_DRAWER = 'SessionContext/updateDrawer';
export const IS_LOADING = 'SessionContext/isLoading';
export const LOGIN = 'SessionContext/login';
export const LOGOUT = 'SessionContext/logout';
export const RELOAD_DATA_ON_REFRESH = 'SessionContext/reloadData';
